/**
 * Shared field-level validators for the list wizards (Add / Edit).
 *
 * Pure and framework-free. Each wizard composes these into its own
 * `validateDraft`, so the name / period rules (and their messages) have a single
 * source of truth and cannot drift between features.
 */

/** @returns an error message, or `undefined` when the name is valid. */
export function validateListName(name: string): string | undefined {
  return name.trim() ? undefined : 'A name is required.';
}

/** Period errors keyed by field. Empty object = valid. */
export interface PeriodErrors {
  startDate?: string;
  endDate?: string;
}

/** Validate the start/end dates: both required, end on or after start. */
export function validateListPeriod(startDate: string, endDate: string): PeriodErrors {
  const errors: PeriodErrors = {};
  if (!startDate) errors.startDate = 'A start date is required.';
  if (!endDate) errors.endDate = 'An end date is required.';
  if (startDate && endDate && endDate < startDate) {
    errors.endDate = 'The end date must be on or after the start date.';
  }
  return errors;
}
